import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["container"];

  get keywords() {
    try {
      return JSON.parse(this.data.get("keywords")) || [];
    } catch (e) {
      return [];
    }
  }

  connect() {
    const weightFromFrequency = freq => freq;

    // Highcharts expect the input data to be in the form of
    // [ { name, weight } ]
    const data = this.keywords.map(([word, frequency]) => ({
      name: word,
      weight: weightFromFrequency(frequency)
    }));

    Promise.all([import("highcharts/highstock"), import("highcharts/modules/wordcloud")]).then(
      res => {
        const Highcharts = res[0];
        const Wordcloud = res[1];
        Wordcloud(Highcharts);

        Highcharts.chart({
          chart: {
            renderTo: this.containerTarget
          },
          tooltip: {
            enabled: false
          },
          series: [
            {
              maxFontSize: 50,
              type: "wordcloud",
              data
            }
          ],
          title: {
            text: null
          }
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./app/assets/webpack/controllers/wordcloud_controller.js